<template>
  <v-card class="elevation-12">
    <template v-if="contract">
      <template v-if="allowApprove || allowDelete || allowEdit">
        <v-card-actions>
          <template v-if="allowApprove">

            <v-dialog v-model="approve.dialog" max-width="560">
              <template v-slot:activator="{on, attrs }">
                <v-btn color="primary" text v-on="on" v-bind="attrs">Подписать</v-btn>
              </template>

              <v-card>
                <v-card-title class="headline">Подписать договор?</v-card-title>
                <v-card-text>
                  При подписании договора, документ будет отправлен на налоговую службу и контрагентам будут доступы через роуминг операторы
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary darken-1" text @click="approve.dialog = false">Нет</v-btn>

                  <v-btn color="green darken-1" text @click="onApproveButtonClicked" v-if="$store.getters.isCertificateLoaded">Да</v-btn>
                  <v-btn color="green darken-1" text @click="certificate.dialog = true" v-else>Да</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="certificate.dialog" max-width="480" :persistent="true">
              <v-card>
                <v-toolbar color="primary" dark flat>
                  <v-toolbar-title> Выбор ключа</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <ActivateCertificate @cancel="certificate.dialog = false" @activated="onApproveButtonClicked(); certificate.dialog = false"/>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="warning" text @click="certificate.dialog = false"> Отменить</v-btn>
                </v-card-actions>
              </v-card>

            </v-dialog>

            <v-snackbar v-model="approve.error" :multi-line="true" :timeout="5000" bottom color="error" outlined right>
              Ошибка при подписании договора
            </v-snackbar>
            <v-snackbar v-model="approve.success" :multi-line="true" :timeout="5000" bottom color="success" outlined right>
              Договор подписан
            </v-snackbar>
          </template>

          <v-spacer/>

          <v-btn v-if="allowEdit" color="primary" text :to="{name: 'edit-contract', params: {id: contract.id}}">
            Редактировать
          </v-btn>

          <template v-if="allowDelete">
            <v-dialog v-model="del.dialog" max-width="560">
              <template v-slot:activator="{on, attrs }">
                <v-btn color="error" text v-on="on" v-bind="attrs">Удалить</v-btn>
              </template>

              <v-card>
                <v-card-title class="headline">Удалить договор из системы?</v-card-title>
                <v-card-text>После удаления восстановить договор невозможно. Необходимо будет создать новый договор. Уверены что хотите продолжить?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary darken-1" text @click="del.dialog = false">Нет</v-btn>
                  <v-btn color="green darken-1" text @click="onDeleteButtonClicked">Да</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-snackbar v-model="del.error" :multi-line="true" :timeout="5000" bottom color="error" outlined right>
              Ошибка при удалении договора
            </v-snackbar>
            <v-snackbar v-model="del.success" :multi-line="true" :timeout="5000" bottom color="success" outlined right>
              Договор удален
            </v-snackbar>
          </template>

        </v-card-actions>

        <v-divider/>
      </template>

      <v-card-text>
        <div class="body-1">
          <b>Номер</b>: {{ contract.number }}
          <br/>
          <b>Дата: </b> {{ contract.date }}
          <br/>
          <b>Наименование: </b> {{ contract.title }}
          <br/>
          <b>Действителен до: </b> {{ contract.expires_on }}
          <br/>
          <b>Место заключения: </b> {{ contract.place }}
        </div>
      </v-card-text>

      <v-divider/>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <h3 class="mb-4">Заказчик</h3>
            <span class="body-1 flex-grow-1">
              <b class="member-property-key d-inline-flex">Название</b> {{ contract.customers[0].company_name }}
              <br/>
              <b class="member-property-key d-inline-flex">Инн </b> {{ contract.customers[0].company_inn }}
              <br/>
  
              <b class="member-property-key d-inline-flex">Инн директора </b> {{ contract.customers[0].physic_inn }}
              <br/>
              <b class="member-property-key d-inline-flex">Директор </b> {{ contract.customers[0].physic_name }}
              <br/>
              <b class="member-property-key d-inline-flex">Телефон </b> {{ contract.customers[0].phone }}
              <br/>
              <b class="member-property-key d-inline-flex">Мобильный </b> {{ contract.customers[0].mobile }}
              <br/>
              <b class="member-property-key d-inline-flex">Адрес </b> {{ contract.customers[0].address }}
              <br/>
              <b class="member-property-key d-inline-flex">Банковский счёт </b> {{ contract.customers[0].bank_account }}
              <br/>
              <b class="member-property-key d-inline-flex">Код банка </b> {{ contract.customers[0].bank_mfo }}
              <br/>
              <b class="member-property-key d-inline-flex">Банк </b> {{ contract.customers[0].bank_name }}
          </span>
          </v-col>
          <v-col cols="12" md="6">
            <h3 class="mb-4">Поставщик</h3>
            <span class="body-1 flex-grow-1">
              <b class="member-property-key d-inline-flex">Название</b> {{ contract.executor.company_name }}
              <br/>
              <b class="member-property-key d-inline-flex">Инн </b> {{ contract.executor.company_inn }}
              <br/>
  
              <b class="member-property-key d-inline-flex">Инн директора </b> {{ contract.executor.physic_inn }}
              <br/>
              <b class="member-property-key d-inline-flex">Директор </b> {{ contract.executor.physic_name }}
              <br/>
              <b class="member-property-key d-inline-flex">Телефон </b> {{ contract.executor.phone }}
              <br/>
              <b class="member-property-key d-inline-flex">Мобильный </b> {{ contract.executor.mobile }}
              <br/>
              <b class="member-property-key d-inline-flex">Адрес </b> {{ contract.executor.address }}
              <br/>
              <b class="member-property-key d-inline-flex">Банковский счёт </b> {{ contract.executor.bank_account }}
              <br/>
              <b class="member-property-key d-inline-flex">Код банка </b> {{ contract.executor.bank_mfo }}
              <br/>
              <b class="member-property-key d-inline-flex">Банк </b> {{ contract.executor.bank_name }}
          </span>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider/>

      <template v-if="contract.items.length > 0">
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th>№</th>
                <th>Товар или услуга</th>
                <th>Код</th>
                <th>Ед.изм</th>
                <th class="text-right">Количество</th>
                <th class="text-right">Цена за единицу</th>
                <th class="text-right">Стоимость</th>
                <th class="text-right">Ставка ндс</th>
                <th class="text-right">Сумма ндс</th>
                <th class="text-right">Стоимость с учётом НДС</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in contract.items" :key="item.id">
                <td class="text-center">{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td class="text-right">{{ item.barcode }}</td>
                <td>{{ item.measurement }}</td>
                <td class="text-right"> {{ item.quantity | decimalNoTrim }}</td>
                <td class="text-right">{{ item.price | decimalNoTrim }}</td>
                <td class="text-right">{{ item.total | decimalNoTrim }}</td>
                <td class="text-right">{{ item.nds_rate | decimalNoTrim }}</td>
                <td class="text-right">
                  {{ item.nds_value | decimalNoTrim }}
                </td>
                <td class="text-right">
                  {{ item.total_with_nds | decimalNoTrim }}
                </td>
              </tr>
              <tr>
                <td class="text-left" colspan="6"><b>Итого: {{ totals.totalWithNdsInWords }}</b></td>
                <td class="text-right"><b>{{ totals.total | decimalNoTrim }}</b></td>
                <td></td>
                <td class="text-right"><b>{{ totals.ndsValue | decimalNoTrim }}</b></td>
                <td class="text-right"><b>{{ totals.totalWithNds | decimalNoTrim }}</b></td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider/>
      </template>

      <v-card-text>
        <div v-for="part in contract.parts" :key="part.id">
          <div class="text-left h4 font-weight-bold pl-8">
            <template v-if="part.order > 0">
              {{ part.order }}.
            </template>
            {{ part.title }}
          </div>

          <p class="">{{ part.body }}</p>
        </div>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import ContractService from "@/services/contract.service";
import _ from 'underscore'
import EIMZO from '@/plugins/eimzo'
import SignService from "@/services/sign/sign.service";
import ActivateCertificate from "@/components/main/sign/ActivateCertificate";
import AmountText from "@/helpers/amount.text";

export default {
  name: "ContractView",
  components: {
    ActivateCertificate
  },
  data: () => ({
    contract: null,
    sendContractApprove: null,
    del: {
      dialog: false,
      error: false,
      success: false
    },
    approve: {
      dialog: false,
      error: false,
      success: false
    },
    certificate: {
      dialog: false
    }
  }),
  computed: {
    isExecutor() {
      if (this.contract)
        return this.contract.executor.company_inn === this.$store.getters.login.company.inn

      return false
    },
    isCustomer() {
      if (this.contract) {
        let customer = _.find(this.contract.customers, c => {
          return c.company_inn === this.$store.getters.login.company.inn
        }) || null

        return customer !== null
      }

      return false
    },

    allowApprove() {
      if (this.contract) {
        if (this.isExecutor) {
          if (this.sendContractApprove && this.sendContractApprove.use_pre_sign_approve)
            return this.sendContractApprove.pre_sign_approved && !this.contract.executor.is_approved && !this.contract.executor.is_declined && !this.contract.executor.on_wait

          return !this.contract.executor.is_approved && !this.contract.executor.is_declined && !this.contract.executor.on_wait
        }
        if (this.isCustomer) {
          // find customer
          let customer = _.find(this.contract.customers, c => {
            return c.company_inn === this.$store.getters.login.company.inn
          }) || null

          if (customer) {
            return !customer.is_approved && !customer.is_declined
          }
        }
      }

      return false
    },
    allowDelete() {
      return false
      // if (this.contract)
      //   if (this.contract.executor.company_inn === this.$store.getters.login.company.inn)
      //     return !this.contract.executor.is_approved && !this.contract.executor.is_declined && !this.contract.executor.on_wait
      //
      // return false
    },
    allowEdit() {
      if (this.contract)
        if (this.contract.executor.company_inn === this.$store.getters.login.company.inn) {
          if (this.sendContractApprove && this.sendContractApprove.use_pre_sign_approve)
            return !this.contract.executor.is_approved && !this.contract.executor.on_wait && !this.sendContractApprove.pre_sign_approved

          return !this.contract.executor.on_wait
        }


      return false
    },
    totals() {
      let total = 0;
      let ndsValue = 0;
      let totalWithNds = 0;

      _.each(this.contract.items, (item) => {
        total += item.total;
        ndsValue += item.nds_value;
        totalWithNds += item.total_with_nds;
      });
      const totalWithNdsInWords = AmountText.getText(totalWithNds)
      return {total, ndsValue, totalWithNds, totalWithNdsInWords};
    },
  },
  methods: {
    load() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      ContractService.getDraftContract(this.$route.params.id)
          .then(response => {
            this.contract = response.data


            if (this.contract.send_contract_approve_id) {
              this.$store.dispatch(LAYOUT_LOADING_START)
              ContractService.getSendDocumentApprove(this.contract.send_contract_approve_id)
                  .then(response => {
                    this.sendContractApprove = response.data
                  })
                  .finally(() => {
                    this.$store.dispatch(LAYOUT_LOADING_STOP)
                  })
            }
          })
          .catch(() => {
            this.$router.go(-1)
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    delete() {
      this.del.error = false
      this.del.success = false
      this.$store.dispatch(LAYOUT_LOADING_START)
      ContractService.deleteDraftContract(this.contract.id)
          .then(() => {
            this.del.success = true
            this.$router.go(-1)
          })
          .catch(() => {
            this.del.error = true
          })
          .finally(() => {
            this.del.dialog = false
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    sign() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      ContractService.getDraftContractSignHashcode(this.contract.id)
          .then(response => {
            const timestampFn = (signatureHex) => {
              return new Promise((resolve, reject) => {
                SignService.getTimeStamp(signatureHex)
                    .then(getTimeStampResponse => {
                      resolve(getTimeStampResponse.data);
                    }, reject);
              })
            };

            let operatorHashcode = response.data.hashcode
            let roamingHashcode = this.isExecutor ? response.data.seller_hashcode : response.data.buyer_hashcode

            if (this.isExecutor) {
              if (response.data.is_roaming) {
                EIMZO.sign(operatorHashcode, roamingHashcode, this.$store.getters.certificate, timestampFn)
                    .then(result => {
                      const signResult = result[0];
                      const attachTimestampResult = result[1];

                      this.$store.dispatch(LAYOUT_LOADING_START)
                      ContractService.signDraftContract(this.contract.id, {
                        certificate_serial: attachTimestampResult.signerSeriaNumber,
                        comment: null,
                        operator_signature: signResult.pkcs7,
                        roaming_signature: attachTimestampResult.pkcs7
                      })
                          .then(() => {
                            this.approve.success = true
                            this.load()
                          })
                          .catch(() => {
                            this.approve.error = true
                          })
                          .finally(() => {
                            this.$store.dispatch(LAYOUT_LOADING_STOP)
                          })
                    })
              } else {
                EIMZO.createPkcs7(operatorHashcode, this.$store.getters.certificate)
                    .then(result => {
                      const signResult = result;

                      this.$store.dispatch(LAYOUT_LOADING_START)
                      ContractService.signDraftContract(this.contract.id, {
                        certificate_serial: signResult.serialNumber,
                        comment: null,
                        operator_signature: signResult.pkcs7,
                        roaming_signature: null
                      })
                          .then(() => {
                            this.approve.success = true
                            this.load()
                          })
                          .catch(() => {
                            this.approve.error = true
                          })
                          .finally(() => {
                            this.$store.dispatch(LAYOUT_LOADING_STOP)
                          })
                    })
              }
            } else {
              if (response.data.is_roaming) {
                EIMZO.signByAttach(operatorHashcode, roamingHashcode, this.$store.getters.certificate, timestampFn)
                    .then(result => {
                      const signResult = result[0];
                      const attachTimestampResult = result[1];

                      this.$store.dispatch(LAYOUT_LOADING_START)
                      ContractService.signDraftContract(this.contract.id, {
                        certificate_serial: attachTimestampResult.signerSeriaNumber,
                        comment: null,
                        operator_signature: signResult.pkcs7,
                        roaming_signature: attachTimestampResult.pkcs7
                      })
                          .then(() => {
                            this.approve.success = true
                            this.load()
                          })
                          .catch(() => {
                            this.approve.error = true
                          })
                          .finally(() => {
                            this.$store.dispatch(LAYOUT_LOADING_STOP)
                          })
                    })
              } else {
                EIMZO.createPkcs7(operatorHashcode, this.$store.getters.certificate)
                    .then(result => {
                      const signResult = result;

                      this.$store.dispatch(LAYOUT_LOADING_START)
                      ContractService.signDraftContract(this.contract.id, {
                        certificate_serial: signResult.serialNumber,
                        comment: null,
                        operator_signature: signResult.pkcs7,
                        roaming_signature: null
                      })
                          .then(() => {
                            this.approve.success = true
                            this.load()
                          })
                          .catch(() => {
                            this.approve.error = true
                          })
                          .finally(() => {
                            this.$store.dispatch(LAYOUT_LOADING_STOP)
                          })
                    })
              }
            }
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    onApproveButtonClicked() {
      this.approve.dialog = false
      this.approve.error = false
      this.approve.success = false

      this.sign()
    },
    onDeleteButtonClicked() {
      this.delete()
    }
  },
  created() {
    this.load()
  },
  watch: {
    "$route.params.id"() {
      this.load();
    },
  },
}
</script>

<style scoped>
.member-property-key {
  width: 180px;
}
</style>